import { CRMAPIBase } from '@api/crmApiBase';
import { OrderStatusResp } from '@api/responseModels/orderStatuses/orderStatusResponse';
import { OrderStatusesResp } from '@api/responseModels/orderStatuses/orderStatusesResponse';
import { RequestResult } from '@api/responseModels/requestResult';

class OrderStatusesGroup extends CRMAPIBase {
    async getOrderStatuses(crm_id: number): Promise<RequestResult<OrderStatusesResp>> {
        const result = await this.get<OrderStatusesResp>(`order-statuses`, {
            crm_id,
            per_page: 20,
        });
        return result;
    }

    async updateOrderStatus({
        id,
        crm_id,
        title,
        color,
        client,
        worker_positions,
    }: {
        id: number;
        crm_id: number;
        title: string;
        color: string;
        client: number;
        worker_positions: number[];
    }): Promise<RequestResult<OrderStatusResp>> {
        const result = await this.put<OrderStatusResp>(`order-statuses/${id}`, {
            crm_id,
            title,
            color,
            client,
            worker_positions,
        });
        return result;
    }
}

export { OrderStatusesGroup };
